import {
  addYears,
  differenceInDays,
  differenceInMinutes,
  differenceInMonths,
  differenceInSeconds,
  differenceInYears,
  format,
  isValid,
  parseISO,
} from 'date-fns';
import type { Nullable } from '../../../api/types.ts';
import { EMPTY_VIEW_VALUE } from '../../constants/index.tsx';


export const doParseDate = (date: string) => parseISO(date);

export const formatDateToDateAndTime = (date?: Nullable<string>) => {
  if (!date) return EMPTY_VIEW_VALUE;
  const parsed = doParseDate(date);
  return format(parsed, 'dd.mm.yyyy ・ HH:mm:ss');
};

export const formatDateToDateAndTimeWithFullMonth = (date?: Nullable<string>) => {
  if (!date) return EMPTY_VIEW_VALUE;
  const parsed = doParseDate(date);
  return format(parsed, 'yyyy MMM dd ・ HH:mm:ss');
};

export const formatDateToDateAndTimeHalfOfYer = (date?: Nullable<string>) => {
  if (!date) return EMPTY_VIEW_VALUE;
  const parsed = doParseDate(date);
  return format(parsed, 'dd.mm.yy ・ HH:mm:ss');
};

export const formatDateToDateAndTimeHalfOfYerAndHalfOfMonth = (date?: Nullable<string>) => {
  if (!date) return EMPTY_VIEW_VALUE;
  const parsed = doParseDate(date);
  return format(parsed, 'd MMM yy・HH:mm');
};


export const getMemberSince = (date: Nullable<string>): Nullable<string> => {
  if (date === null) return EMPTY_VIEW_VALUE;

  const start = doParseDate(date);
  if (!isValid(start)) return EMPTY_VIEW_VALUE;

  const end = new Date();
  if (start >= end) return 'now';

  const years = differenceInYears(end, start);
  const afterYears = addYears(start, years);
  const months = differenceInMonths(end, afterYears);

  if (years > 0 || months > 0) {
    const parts: string[] = [];
    if (years > 0) parts.push(`${years} y`);
    if (months > 0) parts.push(`${months} month`);
    return parts.join(' ');
  }

  const days = differenceInDays(end, start);
  if (days > 0) return `${days} day`;

  const minutes = differenceInMinutes(end, start);
  if (minutes > 0) return `${minutes} minute`;

  const seconds = differenceInSeconds(end, start);
  if (seconds > 0) return `${seconds} second`;

  return 'now';
};